import { render, staticRenderFns } from "./CostOriginValue.vue?vue&type=template&id=565f438c&"
import script from "./CostOriginValue.vue?vue&type=script&lang=js&"
export * from "./CostOriginValue.vue?vue&type=script&lang=js&"
import style0 from "./CostOriginValue.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports